import { render, staticRenderFns } from "./DetectionRequestDetail.vue?vue&type=template&id=13a81b56&scoped=true&"
import script from "./DetectionRequestDetail.vue?vue&type=script&lang=js&"
export * from "./DetectionRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a81b56",
  null
  
)

export default component.exports